import Player from './Player';

// https://developer.spotify.com/documentation/embeds/references/iframe-api#methods
export default class SpotifyPlayer extends Player {
	static #getApiPromise = null;
	#getPlayerPromise = null;
	#endSeconds = 0;

	constructor(elemId, apiKey) {
		super(elemId);
		this.apiKey = apiKey;
	}

	static getName() { return 'Spotify'; }
	static urlMatches(url) {
		var urlInstance = new URL(url);
		return urlInstance.host.endsWith('spotify.com');
	}

	static getApi() {
		return SpotifyPlayer.#getApiPromise = SpotifyPlayer.#getApiPromise || new Promise((resolve, reject) => {
			window.onSpotifyIframeApiReady = (IFrameAPI) => resolve(IFrameAPI);
			const script = document.createElement('script');
			script.src = 'https://open.spotify.com/embed/iframe-api/v1';
			script.async = true;
			script.onerror = reject;
			document.head.appendChild(script);
		});
	}

	// initial call requires URI, subsequent calls do not
	getPlayer(uri) {
		if(!uri && !this.#getPlayerPromise)
			return Promise.reject(new ReferenceError('No URL specified'));

		return this.#getPlayerPromise ||= new Promise((resolve, reject) => {
			return SpotifyPlayer.getApi().then(API => {
				const container = document.getElementById(this.elemId);
				const elem = document.createElement('div');
				container.appendChild(elem);

				try {
					API.createController(elem, {
						uri,
						width: '100%',
						height: '100%',
					}, ctrl => {
						ctrl.addListener('ready', () => resolve(ctrl));
						ctrl.addListener('playback_started', () => this.emit('status', { status: 'playing' }));
						ctrl.addListener('playback_update', e => {
							if(e.data.position == e.data.duration)
								this.emit('status', { status: 'finished' });
							else
								this.emit('progress', e.data.position);
						});
					});
				} catch(e) {
					reject(e);
				}
			});
		});
	}

	async cleanup() {
		const player = await this.getPlayer();
		player.destroy();
	}

	async load(url, startSeconds, endSeconds) {
		const needLoad = !!this.#getPlayerPromise;
		const uri = this.getUriFromUrl(url)
		const player = await this.getPlayer(uri);
		if(needLoad)
			player.loadUri(uri, true, startSeconds);
		this.#endSeconds = endSeconds;
	}

	getUriFromUrl(url) {
		url = new URL(url);
		return `spotify:${url.pathname.split('/').filter(a => !!a).join(':')}`;
	}

	async play() {
		const player = await this.getPlayer();
		player.togglePlay();
	}

	async pause() {
		const player = await this.getPlayer();
		player.pause();
	}

	async togglePause() {
		const player = await this.getPlayer();
		player.togglePlay();
	}

	async stop() {
		const player = await this.getPlayer();
		player.pause();
		player.seek(0);
	}
}
